import { useDayPicker } from 'react-day-picker';
import { NextArrowImg, PreviousArrowImg } from '../../Constants';

export const CustomPreviousButton = ({ onClick }) => {
  const { previousMonth } = useDayPicker();
  if (!previousMonth) return null;

  return (
    <div onClick={onClick} className="custom-prev-button-container" role="button" aria-label="Previous Month">
      <img src={PreviousArrowImg} alt="Previous Month" />
    </div>
  );
};

export const CustomNextButton = ({ onClick }) => {
  const { nextMonth } = useDayPicker();
  if (!nextMonth) return null;

  return (
    <div onClick={onClick} className="custom-next-button-container" role="button" aria-label="Next Month">
      <img src={NextArrowImg} alt="Next Month" />
    </div>
  );
};
